/**
 * Agents resource - /api/agents endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.AgentsResource');
export class AgentsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * List all available agents
     */
    async list() {
        log.debug('Listing agents');
        const response = await this.http.get('/api/agents');
        log.debug('Agents listed', { count: response.total });
        return response;
    }
    /**
     * Get agent by name
     */
    async getByName(name) {
        try {
            log.debug('Getting agent by name', { name });
            const response = await this.http.get(`/api/agents/${encodeURIComponent(name)}`);
            log.debug('Agent retrieved', { name });
            return response.agent;
        }
        catch (error) {
            if (error.statusCode === 404) {
                log.debug('Agent not found', { name });
                return null;
            }
            throw error;
        }
    }
    /**
     * Create a new agent
     */
    async create(data) {
        log.debug('Creating agent', { name: data.name });
        const response = await this.http.post('/api/agents', data);
        log.debug('Agent created', { name: data.name });
        return response.agent;
    }
    /**
     * Update an existing agent
     */
    async update(name, data) {
        log.debug('Updating agent', { name });
        const response = await this.http.patch(`/api/agents/${encodeURIComponent(name)}`, data);
        log.debug('Agent updated', { name });
        return response.agent;
    }
    /**
     * Delete an agent
     */
    async delete(name) {
        log.debug('Deleting agent', { name });
        await this.http.delete(`/api/agents/${encodeURIComponent(name)}`);
        log.debug('Agent deleted', { name });
    }
}
//# sourceMappingURL=AgentsResource.js.map